import { render, staticRenderFns } from "./ViewHotsites.vue?vue&type=template&id=1904d969&scoped=true&"
import script from "./ViewHotsites.vue?vue&type=script&lang=ts&"
export * from "./ViewHotsites.vue?vue&type=script&lang=ts&"
import style0 from "./ViewHotsites.vue?vue&type=style&index=0&id=1904d969&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1904d969",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAutocomplete,VChip,VContainer,VSelect})
